import { Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    width: "90vw",
    maxWidth: "1200px",
    height: "90vh",
    maxHeight: "800px",
    margin: 0,
    borderRadius: "12px",
    overflow: "hidden",
  },
}));

export const ModalContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: "100%",
});

export const ModalTopContainer = styled("div")({
  padding: "20px 24px 16px 24px",
  borderBottom: "1px solid #E0E0E0",
  backgroundColor: "#FFFFFF",
});

export const TitleContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const Text = styled("div")(({ $text }) => ({
  ...(($text === "title") && {
    fontSize: "20px",
    fontWeight: "600",
    color: "#1A1A1A",
    lineHeight: "24px",
  }),
}));

export const CloseIconStyled = styled(CloseIcon)({
  cursor: "pointer",
  color: "#666666",
  fontSize: "24px",
  "&:hover": {
    color: "#333333",
  },
});

export const IframeStyled = styled("iframe")({
  flex: 1,
  border: "none",
  width: "100%",
  height: "100%",
  minHeight: "500px",
});
